import moment from 'moment'

const twoHoursAgo = moment().hour() - 2
const closestFifteen = Math.floor(moment().minute()/15) * 15

const initialState = {
  visits: [],
  unverifiedVisits: [],
  loadMore: false,
  params: {
    licensePlate: null,
    startDate: moment().hour(twoHoursAgo).minute(closestFifteen).format("YYYY-MM-DD HH:mm:ssZZ"),
    startDateMoment: moment().hour(twoHoursAgo).minute(closestFifteen),
    endDate: moment().endOf('day').format("YYYY-MM-DD HH:mm:ssZZ"),
    endDateMoment: moment().endOf('day'),
    locationId: null,
    bay: null,
  },
  visit: null,
  recording: null,
  user: null
}

export default function visits(state=initialState, action) {

  switch (action.type) {

    case 'FETCH_VISITS':
      if(action.visits.length === 50) {
        return {...state, visits: action.visits, loadMore: true}
      }
      return {...state, visits: action.visits};
    case 'FETCH_MORE_VISITS':
      if(action.visits.length < 50) {
        return {...state, visits: [...state.visits, ...action.visits], loadMore: false}
      }
      return {...state, visits: [...state.visits, ...action.visits]};
    case 'FETCH_SINGLE_VISIT':
      return {...state, visit: action.visit}
    case 'FETCH_RECORDING':
      return {...state, recording: action.recording}
    case 'UPDATE_PARAMS':
      let updatedParams = {...state.params, ...action.params}
      if(updatedParams.startDateMoment) {
        updatedParams['startDate'] = action.params.startDateMoment.format("YYYY-MM-DD HH:mm:ssZZ")
      }
      if(updatedParams.endDateMoment) {
        updatedParams['endDate'] = action.params.endDateMoment.format("YYYY-MM-DD HH:mm:ssZZ")
      }
      return {...state, params: updatedParams}
    case 'PASS_USER_DATA_FOR_DEMO_ACCOUNT':
      if(action.user.is_demo_user) {
        let demoParams = {...state.params, ...action.params}
        demoParams['startDate'] = moment().year(2019).month(0).date(1).format("YYYY-MM-DD HH:mm:ssZZ");
        demoParams['startDateMoment'] = moment().year(2019).month(0).date(1);
        return {...state, params: demoParams}
      } else {
        let demoParams = {...state.params, ...action.params}
        demoParams['startDate'] = moment().hour(twoHoursAgo).minute(closestFifteen).format("YYYY-MM-DD HH:mm:ssZZ")
        demoParams['startDateMoment'] = moment().hour(twoHoursAgo).minute(closestFifteen)
        return {...state, params: demoParams}
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/visits.js